import { DeleteOutline } from "@mui/icons-material";
import { IconButton, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { InfoBox, ListContainer, StyledUserCard, AvatarCircle } from "./styles";

interface IUser {
  id: number;
  name: string;
  cpf: string;
}

interface UserListProps {
  users: IUser[] | null;
  onDelete?: (id: number) => void;
  deletingUserId?: number | null;
}

const UserList: React.FC<UserListProps> = ({ users, onDelete, deletingUserId }) => {
  const getInitials = (name: string) =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();

  return (
    <ListContainer>
      <Typography
        variant="h6"
        sx={{
          mb: 1.5,
          fontWeight: "bold",
          color: "#0B3095",
          textTransform: "uppercase",
          fontSize: 14,
        }}
      >
        Lista de Usuários
      </Typography>

      <ul style={{ margin: 0, padding: 0 }}>
        {users && users.length > 0 ? (
          users.map((user) => (
            <StyledUserCard key={user.id}>
              <AvatarCircle>{getInitials(user.name)}</AvatarCircle>

              <InfoBox>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 260,
                    textTransform: "uppercase",
                    fontSize: 14,

                  }}
                  title={user.name}
                >
                  {user.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
                  CPF: {user.cpf}
                </Typography>
              </InfoBox>

              <IconButton
                color="error"
                onClick={() => onDelete?.(user.id)}
                disabled={deletingUserId === user.id}
              >
                {deletingUserId === user.id ? (
                  <CircularProgress size={22} color="error" />
                ) : (
                  <DeleteOutline />
                )}
              </IconButton>
            </StyledUserCard>
          ))
        ) : (
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            Nenhum usuário encontrado.
          </Typography>
        )}
      </ul>
    </ListContainer>
  );
};

export default UserList;
